/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Center navigation cluster for the public/landing GlobalHeader.
 */

import { useTranslation } from 'react-i18next';
import { FF_BLOG, FF_EARLY_ACCESS } from '@/shared/utils/feature-flag';
import { NavButton, NavLink } from './GlobalHeader.parts';

export interface CenterNavSections {
  levels: boolean;
  recursos: boolean;
  faq: boolean;
  features: boolean;
  pricing: boolean;
}

interface CenterNavProps {
  sections: CenterNavSections;
  isAuthenticated: boolean;
  isEarlyAccessPage: boolean;
  isBlogPage: boolean;
  hoveredNav: string | null;
  setHoveredNav: (id: string | null) => void;
  onScroll: (id: string) => void;
}

export const CenterNav: React.FC<CenterNavProps> = ({
  sections,
  isAuthenticated,
  isEarlyAccessPage,
  isBlogPage,
  hoveredNav,
  setHoveredNav,
  onScroll,
}) => {
  const { t } = useTranslation('@pages/landing');
  const hover = { hoveredNav, setHoveredNav };
  return (
    <div className="flex-1 flex items-center justify-center gap-(--space-10)">
      {FF_EARLY_ACCESS ? (
        <>
          <NavButton id="levels" label={t('navigation.plansAndLevels')} isActive={sections.levels} onClick={() => onScroll('levels')} {...hover} />
          <NavButton id="recursos" label={t('navigation.resources')} isActive={sections.recursos} onClick={() => onScroll('recursos')} {...hover} />
          <NavButton id="faq" label={t('navigation.faq')} isActive={sections.faq} onClick={() => onScroll('faq')} {...hover} />
          {isAuthenticated && (
            <NavLink id="early-access" label={t('navigation.earlyAccess')} to="/early-access" isActive={isEarlyAccessPage} {...hover} />
          )}
        </>
      ) : (
        <>
          <NavButton id="features" label={t('navigation.features', 'Features')} isActive={sections.features} onClick={() => onScroll('features')} {...hover} />
          <NavButton id="pricing" label={t('navigation.pricing', 'Pricing')} isActive={sections.pricing} onClick={() => onScroll('pricing')} {...hover} />
        </>
      )}
      {FF_BLOG && (
        <NavLink id="blog" label={t('navigation.blog')} to="/blog" isActive={isBlogPage} {...hover} />
      )}
    </div>
  );
};
